<div class="mat-dialog-container">
  <!-- 明細編輯開始 -->
  <div #head>
    <app-modal-header #modal_header [isDialog]="isDialog" [title]="title" [state]="srv.state" (onOkClick)="doOk($event)"
      (onEditAndSaveClick)="doEditAndSave($event)"
      (onCancelClick)="doCancel($event)">
    </app-modal-header>
  </div>
  <div class="jk-content">
    <div class="jk-grid-cols-2">
      <app-jktext label="序號" [value]="item.WC003">
      </app-jktext>
      <app-jkdatefield label="日期" #WC004Com id="WC004" [(value)]="item.WC004" [required]="true" placeholder="日期"
        [readonly]="isBrowse">
      </app-jkdatefield>

      <app-jk-rich-editor [minHeight]="'250px'" label="問題敘述說明" [readonly]="isBrowse" [(value)]="item.WC005"
        [required]="true" [path]="getImagePath(item)" [host]="srv.host">
      </app-jk-rich-editor>
      <app-jk-rich-editor [minHeight]="'250px'" [(value)]="item.WC006" [readonly]="isBrowse" label="處理說明"
        [required]="false" [path]="getImagePath(item)" [host]="srv.host">
      </app-jk-rich-editor>

      <app-jktext label="單別" #WC001Com id="WC001" [(value)]="item.WC001" [required]="true" placeholder="單別">
      </app-jktext>
      <app-jktext label="單號" [value]="item.WC002">
      </app-jktext>

    </div>
  </div>
</div>
